<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Select treatment for {{titleString}}</h5>
                <a class="close" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">

                <div *ngIf="error" class="alert alert-danger" style="color: white;">{{error}}</div>

                <ng-container *ngFor="let t of treatments; let idx = index">
                    <div class="timeslot-container">
                        <div class="row mb-3" style="border-bottom: 1px solid #eee;">
                            <div class="col-9">
                                <p class="text-gray-800 mb-1" style="font-size: 16px;">{{t.offering.name}}</p>
                                <p *ngIf="t.price_change" class="text-sm mb-0">+ {{(t.price_change / 100) | currency : 'GBP'}}</p>
                                <p class="text-gray-500 text-sm mb-2">Duration {{t.offering.duration}} minutes</p>
                                <div *ngIf="idx !== treatmentIdx" class=" mb-2 text-gray-500 text-sm" [innerHTML]="t.offering.description"></div>

                                <ng-container *ngIf="t.timeslots && idx === treatmentIdx">
                                    <p class="text-gray-800 mb-1">Select your timeslot</p>
                                    <div
                                        class="timeslot"
                                        [ngClass]="{'selected' : tIdx === timeslotIdx}"
                                        *ngFor="let ts of t.timeslots; let tIdx = index"
                                        (click)="selectSlot(ts, tIdx)">{{ts.start_time | date: 'HH:mm'}}</div>
                                        <div class="mb-2"></div>
                                </ng-container>
                            </div>
                            <div class="col-3">
                                <div class="flex-shrink-0 w-[100px] mt-2 aspect-square overflow-hidden rounded-md bg-gray-100 flex items-center justify-center">
                                    <img [src]="t.offering.image.url" class="w-full h-full aspect-square object-center object-cover">
                                </div>
                                <div>
                                    <button *ngIf="!timeslotSelected || idx !== treatmentIdx" class="btn btn-primary" type="button" (click)="getTimes(idx)">Select</button>
                                    <button *ngIf="timeslotSelected && idx === treatmentIdx" class="btn btn-danger" type="button" (click)="confirmSlot()">Confirm</button>
                                </div>
                        </div>
                        </div>

                        <!-- <div class="p-2 hover" style="border-bottom: 1px solid #eee;" *ngFor="let slot of timeslots" (click)="selectSlot(slot)">
                            <div class="row">
                                <div class="col-4">{{slot.start_time | date : 'HH:mm'}}</div>
                                <div class="col-4">{{slot.total_cost / 100 | currency : 'GBP'}}</div>
                                <div class="col-4">{{slot.appointments.length}} left</div>
                            </div>
                        </div> -->
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade show modal-slide-show"></div>
